import { formatMonto } from "@/utils";
import DatetimeFormatter from "@/components/functionals/DatetimeFormatter.vue";
export const TotaldeConsumosDetailledColumns = [
  {
    prop: "clienteid",
    label: "ID",
    minWidth: 100,
    align: "center",
    sortable: true,
    fixed: false
  },
  // {
  //   prop: "nombre",
  //   label: "Cliente",
  //   minWidth: 170,
  //   sortable: true,
  //   fixed: false
  //   //formatter: hyperlinkNFC
  // },
  {
    prop: "fechaHora",
    label: "Fecha / Hora",
    minWidth: 170,
    sortable: true,
    fixed: false,
    formatter: DatetimeFormatter
  },
  {
    prop: "tarjetaid",
    label: "Tarjeta",
    minWidth: 100,
    align: "center",
    sortable: true,
    fixed: false
    //formatter: Ncf
  },
  {
    prop: "tipoTarjeta",
    label: "Tipo de tarjeta",
    minWidth: 110,
    align: "center",
    sortable: true,
    fixed: false
  },
  {
    prop: "tipodeControl",
    label: "Tipo de control",
    minWidth: 110,
    align: "center",
    sortable: true,
    fixed: false
    // formatter: row => formatMonto(row.gal)
  },
  {
    prop: "tarjetahabienteid",
    label: "Tarjeta ambiente",
    minWidth: 110,
    align: "center",
    sortable: true,
    fixed: false
    // formatter: row => formatMonto(row.gal)
  },
  {
    prop: "monto",
    label: "Monto del consumo en pesos",
    minWidth: 110,
    align: "center",
    sortable: true,
    fixed: false,
    formatter: (row) => formatMonto(row.monto)
  },
  {
    prop: "gal",
    label: "Galones consumidos",
    minWidth: 110,
    align: "center",
    sortable: true,
    fixed: false,
    formatter: (row) => formatMonto(row.gal)
  },
  {
    prop: "producto",
    label: "Productos consumidos",
    minWidth: 110,
    align: "center",
    sortable: true,
    fixed: false
  },
  {
    prop: "estacion",
    label: "Estación",
    minWidth: 110,
    align: "center",
    sortable: true,
    fixed: false
    // formatter: row => formatMonto(row.gal)
  },
  {
    prop: "estacionPrincipal",
    label: "Estación principal",
    minWidth: 110,
    align: "center",
    sortable: true,
    fixed: false
    // formatter: row => formatMonto(row.gal)
  },
  {
    prop: "operadorDespachador",
    label: "Operador de despacho",
    minWidth: 110,
    align: "center",
    sortable: true,
    fixed: false
    // formatter: row => formatMonto(row.gal)
  }
];

export const TotaldeConsumosDetailledActions = [
  {
    icon: "el-icon-s-data",
    label: "Actualizar balance",
    command: "update-balance-command"
  }
];
